import { Navigate } from 'react-router-dom';
import { EmptyState } from '../components/EmptyState';
import { Button } from '../components/Button';
import { useSession } from '../lib/useSession';
import { homeForRole } from '../lib/home';

/** `/`: espera la sesión y lleva a cada persona a su área (consola, terreno u operador). */
export function HomeRedirect() {
  const { status, memberships, activeOrg, user, logout } = useSession();
  if (status === 'loading') {
    return <div className="p-6 text-sm text-ink-muted" role="status">Cargando…</div>;
  }
  if (status === 'signed-out' || !user) return <Navigate to="/login" replace />;
  if (!memberships.length || !activeOrg) {
    return (
      <main className="mx-auto max-w-xl px-4 py-16">
        <EmptyState
          title="Tu cuenta aún no pertenece a una organización"
          description={`Entraste como ${user.email ?? 'usuario sin email'}. Pide a quien administra tu organización que te invite.`}
          action={<Button variant="secondary" onClick={() => void logout()}>Salir</Button>}
        />
      </main>
    );
  }
  return <Navigate to={homeForRole(activeOrg.role)} replace />;
}
